import { normalizeValidationId } from '../validationConstants';

export function describeReconnectIssueKind(validationId: number): string {
  switch (normalizeValidationId(validationId)) {
    case 22:
      return 'system-break';
    case 28:
      return 'geometric-overlap';
    default:
      return 'connector-break';
  }
}

export function buildReconnectAllUnresolvedDetail(validationId: number): string {
  const issueKind = describeReconnectIssueKind(validationId);
  return `Reconnect all finished, but the ${issueKind} validation still reports unresolved issues.`;
}

export function buildReconnectAllUnresolvedToast(validationId: number): string {
  const issueKind = describeReconnectIssueKind(validationId);
  return `Reconnect all finished, but validation still shows unresolved ${issueKind} issues.`;
}
